module.exports = __webpack_public_path__ + "static/media/sms-icon.5a57a85a.svg";